/** Keep in sync with backend `lib/workoutActivity.ts` (ids + MET map for preview). */
export const WEIGHTLIFTING = 'weightlifting' as const;

export const WORKOUT_ACTIVITY_TYPES = [
  { id: WEIGHTLIFTING, label: 'Weightlifting / strength', cardio: false },
  { id: 'treadmill', label: 'Treadmill / indoor run', cardio: true },
  { id: 'outdoor_run', label: 'Outdoor run', cardio: true },
  { id: 'outdoor_walk', label: 'Outdoor walk', cardio: true },
  { id: 'elliptical', label: 'Elliptical', cardio: true },
  { id: 'stationary_bike', label: 'Stationary bike', cardio: true },
  { id: 'spin_class', label: 'Spin / indoor cycling class', cardio: true },
  { id: 'outdoor_ride', label: 'Outdoor ride', cardio: true },
  { id: 'swim', label: 'Swim', cardio: true },
  { id: 'rower', label: 'Rower / rowing machine', cardio: true },
  { id: 'stair_climber', label: 'Stair climber / step mill', cardio: true },
  { id: 'hike', label: 'Hike', cardio: true },
  { id: 'hiit', label: 'HIIT / circuit', cardio: true },
  { id: 'yoga', label: 'Yoga', cardio: true },
  { id: 'pilates', label: 'Pilates', cardio: true },
  { id: 'sports', label: 'Sports / game', cardio: true },
  { id: 'dance', label: 'Dance', cardio: true },
  { id: 'other_cardio', label: 'Other cardio', cardio: true },
  { id: 'multisport', label: 'Brick / triathlon / multisport', cardio: true },
] as const;

export type WorkoutActivityId = (typeof WORKOUT_ACTIVITY_TYPES)[number]['id'];

export function normalizeActivityType(raw: unknown): string {
  const allowed = new Set(WORKOUT_ACTIVITY_TYPES.map((x) => x.id));
  const s = String(raw ?? WEIGHTLIFTING).trim();
  return allowed.has(s as WorkoutActivityId) ? s : WEIGHTLIFTING;
}

export function isCardioActivityType(activityType: string): boolean {
  return WORKOUT_ACTIVITY_TYPES.some((x) => x.id === activityType && x.cardio);
}

export function estimateCardioCalories(
  bodyWeightKg: number | null | undefined,
  durationMinutes: number | null | undefined,
  activityType: string,
): number {
  const w = bodyWeightKg != null && bodyWeightKg > 0 ? bodyWeightKg : 70;
  const metMap: Record<string, number> = {
    treadmill: 9,
    outdoor_run: 9.5,
    outdoor_walk: 3.8,
    elliptical: 5,
    stationary_bike: 7,
    spin_class: 8.5,
    outdoor_ride: 8,
    swim: 8,
    rower: 8.5,
    stair_climber: 9,
    hike: 6,
    hiit: 8,
    yoga: 3,
    pilates: 3.5,
    sports: 6,
    dance: 6,
    other_cardio: 6,
    multisport: 8,
  };
  const met = metMap[activityType] ?? 6;
  let dm =
    durationMinutes != null && Number.isFinite(durationMinutes) && durationMinutes > 0
      ? Math.min(1440, Math.max(1, Math.round(durationMinutes)))
      : 0;
  if (dm <= 0) dm = 25;
  const kcalPerMin = (met * 3.5 * w) / 200;
  return Math.max(1, Math.round(kcalPerMin * dm));
}
